/**
 * La famille d'une machine se CHOISIT dans une liste (Benjamin, 2026-10-27 : « oui pour la liste »), après qu'une désignation
 * eut été tapée dans ce champ libre (« KAESER-BSD72/1263-100253.0 » devenu une famille du Parc).
 *
 * La liste vient des familles DÉJÀ employées par l'espace, les plus fréquentes d'abord : le produit n'impose aucune
 * nomenclature (CDC §1). « Autre… » ouvre une saisie libre pour une famille nouvelle ; un texte qui ressemble à une
 * désignation (numéro de série ou référence) est signalé avant l'enregistrement, jamais refusé.
 */

export const AUTRE_FAMILLE = '__autre__';

export interface FamilleComptee {
  readonly assetType: string;
  readonly count: number;
}

/** Les familles à proposer : les plus fréquentes d'abord, puis par ordre alphabétique ; la famille actuelle toujours présente. */
export function famillesProposees(parNature: readonly FamilleComptee[], actuelle: string): string[] {
  const vues = new Map<string, number>();
  for (const f of parNature) {
    const nom = f.assetType.trim();
    if (nom !== '') vues.set(nom, (vues.get(nom) ?? 0) + f.count);
  }
  const liste = [...vues.entries()]
    .sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0], 'fr'))
    .map(([nom]) => nom);
  const courante = actuelle.trim();
  if (courante !== '' && !liste.includes(courante)) liste.push(courante);
  return liste;
}

/** Le message à montrer quand une famille ressemble à une désignation de machine ; `null` sinon. */
export function avertissementFamille(famille: string): string | null {
  const v = famille.trim();
  if (v === '') return null;
  // « Séparateur huile/eau » est une vraie famille : une barre oblique n'alerte qu'accompagnée d'un chiffre.
  if ((v.includes('/') && /\d/.test(v)) || /\d{3,}/.test(v)) {
    return 'Cette famille ressemble à une désignation de machine (numéro de série ou référence). La famille est un genre de machine : Compresseur, Sécheur, Filtre…';
  }
  return null;
}
